<template>
  <div style="height: 100%">
    <div class="menuBox">
      <Menu :active-name="advancedSettingActive" @on-select="handlerOnSelect">
        <MenuItem name="generalSetting">流程通用设置</MenuItem>
        <!-- <MenuItem name="permission">权限设置</MenuItem> -->
      </Menu>
      <div
        class="advancedSettingMain"
        v-show="advancedSettingActive == 'generalSetting'"
      >
        <GeneralSetting ref="generalSettingRef" :generalData.sync="formData" />
      </div>
      <div
        class="advancedSettingMain"
        v-show="advancedSettingActive == 'permission'"
      >
        <PermissionSetting />
      </div>
    </div>
  </div>
</template>
<script>
import GeneralSetting from './GeneralSetting.vue';
import PermissionSetting from './PermissionSetting.vue';
import {
  saveAdvancedSettings,
  getAdvancedSettingsData
} from '@/api/tempApproval';
import { rmMultiOneOrManyMap, applyAuditMap } from './modalConfig';
export default {
  components: { GeneralSetting, PermissionSetting },
  props: {
    type: {
      type: String,
      default: 'create'
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      advancedSettingActive: 'generalSetting',
      formData: {
        rmMulti: false,
        applyAuditSwitch: false, // 审批人和发起人是同一时，配置开关
        applyAuditSetting: '', // 审批人和发起人配置
        rmMultiOneOrMany: '',
        onlyRollbackLast: false,
        allowEdit: false,
        allowAddAduit: true,
        allowRecall: false,
        allowWithdrawAuditDays: false,
        allwRecallSetDay: 1,
        allowAuditEdit: false,
        allwAuditSetDay: 1,
        allwAuditSetTime: 1,
        allowRollbackApply: false
        // allowAddAduit: '', // [是否允许加签] 1：是，0：否   😩
        // allowModifyAuditDays: '', // [允许修改审批中的天数]0: 不允许，大于0允许的天数，默认90 😩
        // allowModifyFinishDays: '', // [允许修改已完结的天数] 0: 不允许，大于0允许的天数 😩
        // allowWithdrawAuditDays: '', // [允许撤销审批中的天数]0: 不允许，大于0允许的天数，默认90 😩
        // allowWithdrawFinishDays: '', // [允许撤销已完结的天数] 0: 不允许，大于0允许的天数 😩
        // rmMultiAduit: '', // [去重审批人同一人多次出现] 1：是，0：否     😩
        // rmMultiSeqAduit: '' // [去重连续多次出现] 1：是，0：否         😩
        // allowModifyFinishNum : '' // [允许修改已完结的最大次数] 0: 不允许，大于0允许的最大次数  😩
        // allowRollbackApply: '' // [是否可以打回发起人] 0:否，1：是
      }
    };
  },
  methods: {
    handlerOnSelect(value) {
      if (value == this.advancedSettingActive) return false;
      this.advancedSettingActive = value;
    },
    getSubmitData() {
      // 先判断去自动去重
      // 同一审批人在流程中多次出现，自动去重
      const flag = this.$refs.generalSettingRef.validateSettingForm();
      if (!flag) {
        return false;
      }
      const data = {};
      if (!this.formData.rmMulti) {
        data.rmMultiSeqAduit = 0;
        data.rmMultiAduit = 0;
      } else {
        const { rmMultiSeqAduit, rmMultiAduit } = rmMultiOneOrManyMap[
          this.formData.rmMultiOneOrMany
        ];
        data.rmMultiSeqAduit = rmMultiSeqAduit;
        data.rmMultiAduit = rmMultiAduit;
      }
      // 审批人和发起人是同一个人相关配置
      if (!this.formData.applyAuditSwitch) {
        data.rmApplyAduitSame = 0;
        data.allowApplyAuditSame = 1;
      } else {
        const { rmApplyAduitSame, allowApplyAuditSame } = applyAuditMap[
          this.formData.applyAuditSetting
        ];
        data.rmApplyAduitSame = rmApplyAduitSame;
        data.allowApplyAuditSame = allowApplyAuditSame;
      }
      // 允许加签
      data.allowAddAduit = this.formData.allowAddAduit ? 1 : 0;
      // 撤销设置
      // 撤销已通过的审批单
      data.allowWithdrawFinishDays = this.formData.allowRecall
        ? this.formData.allwRecallSetDay
        : 0;
      // 撤销 审批中的审批单
      data.allowWithdrawAuditDays = this.formData.allowWithdrawAuditDays
        ? 90
        : 0;
      // 修改设置
      // 允许提交人修改审批中的审批单（最多90天）
      data.allowModifyAuditDays = this.formData.allowAuditEdit ? 90 : 0;
      // 只允许修改多少天内提交并且通过的审批，最多匀速修改 n 次
      if (this.formData.allowEdit) {
        // 多少天
        data.allowModifyFinishDays = this.formData.allwAuditSetDay;
        // 多少次
        data.allowModifyFinishNum = this.formData.allwAuditSetTime;
      } else {
        // 多少天
        data.allowModifyFinishDays = 0;
        // 多少次
        data.allowModifyFinishNum = 0;
      }
      // 只能退回上一审批节点
      data.onlyRollbackLast = this.formData.onlyRollbackLast ? 1 : 0;
      // 是否可以打回发起人
      data.allowRollbackApply = this.formData.allowRollbackApply ? 1 : 0;
      return data;
    },
    submitAdvanced(tplConfigId) {
      return new Promise(resolve => {
        const submitData = this.getSubmitData();
        if (!submitData) return false;
        const data = { ...submitData, tplConfigId };
        saveAdvancedSettings(data).then(res => {
          const { code } = res.data;
          if (code == 200) {
            resolve(true);
          }
        });
      });
    },
    getUseData(data) {
      const newFormData = {
        allowAddAduit: data.allowAddAduit == null ? true : !!data.allowAddAduit,
        allowAuditEdit: data.allowModifyAuditDays == 90,
        allwAuditSetDay: data.allowModifyFinishDays,
        allwAuditSetTime: data.allowModifyFinishNum,
        allowEdit: !!data.allowModifyFinishDays && !!data.allowModifyFinishNum,
        allowWithdrawAuditDays: data.allowWithdrawAuditDays == 90,
        allwRecallSetDay: data.allowWithdrawFinishDays,
        allowRecall: !!data.allowWithdrawFinishDays,
        rmMulti: !!data.rmMultiAduit || !!data.rmMultiSeqAduit,
        applyAuditSwitch: !!data.rmApplyAduitSame || data.allowApplyAuditSame == 0, // 单选组件已选择
        onlyRollbackLast: !!data.onlyRollbackLast,
        allowRollbackApply: !!data.allowRollbackApply
      };
      // 如果是在流程中多次出现，仅保留第一个， rmMultiOneOrMany = one
      // 如果是仅在连续出现时，自动去重， rmMultiOneOrMany = may
      if (data.rmMultiAduit) {
        newFormData.rmMultiOneOrMany = 'one';
      } else if (data.rmMultiSeqAduit) {
        newFormData.rmMultiOneOrMany = 'may';
      } else {
        newFormData.rmMultiOneOrMany = '';
      }
      /*
        审批人和发起人是同一个人情况下（默认关闭该配置，开启则选择以下一种）
        1.自动通过
        2.该流程审批、办理节点屏蔽该审批人
      */
      if (data.rmApplyAduitSame) { // 1.自动通过
        newFormData.applyAuditSetting = 's1';
      } else if (data.allowApplyAuditSame == 0) { // 2.该流程审批、办理节点屏蔽该审批人
        newFormData.applyAuditSetting = 's2';
      } else { // 开关关闭
        newFormData.applyAuditSetting = '';
      }
      return newFormData;
    },
    async getDetail() {
      const res = await getAdvancedSettingsData(this.id);
      const { data } = res.data;
      const useData = this.getUseData(data);
      this.formData = useData;
    }
  },
  mounted() {
    this.type == 'edit' && this.getDetail();
  }
};
</script>
<style lang="less" scoped>
.menuBox {
  height: 100%;
  display: flex;
  /deep/ .ivu-menu {
    height: 100%;
  }
  .advancedSettingMain {
    background-color: #fff;
    flex: 1;
    margin-left: 20px;
    padding: 10px;
    overflow: scroll;
  }
}
</style>
